/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbSharedRefineMenuTypeaheadContainer_itemSearch$ref = any;
export type SbSharedRefineMenuTypeaheadContainer_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly " $refType": SbSharedRefineMenuTypeaheadContainer_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuTypeaheadContainer_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "topCategoryL1",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '62c5f933a2ecad5307c4c333225f9f21';
export default node;
